import Middle_Bb from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Middle-Bb.mp3";
import Low_Bb from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Low-Bb.mp3";
import Low_B from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Low-B.mp3";
import Middle_C from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Middle-C.mp3";
import Middle_D from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Middle-D.mp3";
import Middle_Eb from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Middle-Eb.mp3";
import Middle_F from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Middle-F.mp3";
import High_G from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/High-G.mp3";
import High_A from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/High-A.mp3";
import High_Bb from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/High-Bb.mp3";
import Low_Db from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Low-Db.mp3";
import Low_E from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Low-E.mp3";
import Middle_Gb from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Low-Gb.mp3";
import Middle_Ab from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Middle-Ab.mp3";

export const altoSaxSounds = {
  middle_Bb: new Audio(Middle_Bb),
  middle_C: new Audio(Middle_C),
  middle_D: new Audio(Middle_D),
  middle_Eb: new Audio(Middle_Eb),
  middle_F: new Audio(Middle_F),
  high_G: new Audio(High_G),
  high_A: new Audio(High_A),
  high_Bb: new Audio(High_Bb),
  //for chromatic intervals
  low_Bb: new Audio(Low_Bb),
  low_B: new Audio(Low_B),
  low_Db: new Audio(Low_Db),
  low_E: new Audio(Low_E),
  middle_Gb: new Audio(Middle_Gb),
  middle_Ab: new Audio(Middle_Ab),


}